<template>
  <div style="padding-bottom: 20px;">
            <center>
      <p style="line-height:1;">
        <v-icon small style="margin-right: 10px;" color="red">mdi-alert</v-icon>
        <small style="color: orange;"><b>
          Esto es un PROTOTIPO y se encuentra en DESARROLLO !!! <br/> [ uso ORIENTATIVO ]
        </b></small>
      </p>
      <v-progress-linear
        v-if="loadingData"
        indeterminate
        color="primary"
      />
      <div>
        <!--PreviewV2
          v-if="config && isDev"
          :config="config"
        /-->
        <preview
          v-if="config"
          :config="config"
        />
      </div>
    </center>
  </div>
</template>
<script>
import apiBrightsign from '@/services/apiBrightsign'
import Preview from '../list/previewPresentation/preview/Index'
//import PreviewV2 from '../list/previewPresentation/previewV2/Index'
export default {
  components: {
    Preview,
    //PreviewV2,
  }, 
  data: () => ({
    config: null,
    loadingData: false,
    loading: false,
    zones: null,
    zonesNew: null,
    isVertical: false,
    speedFactor: 1,
    showInfo: false,
    presentationWidth: null,
    presentationHeight: null,
    medias: null,
  }),
  computed: {
    network () {
      return this.$route.params.network
    },
    token () {
      return this.$route.params.token
    },
    isDev () {
      return process.env.VUE_APP_ENV === 'development' ? true : false
    },
    width () {
      return 800
    },
  },
  mounted () {
    this.handleGetPreviewData()
  },
  methods: {
    convertSize (v) {
      if (!v) return v
      if (typeof v === 'string') return v.replace('px', '') | 0
      return v
    },
    calcSize (width, presentationWidth, v) {
      const aux = (width * this.convertSize(v)) / presentationWidth//1920
      return `${aux}px`
    },
    async handleGetPreviewData () {
      try {
        this.loading = true
        this.config = null
        this.zones = null
        this.zonesNew = null
        this.isVertical = false
        this.loadingData = true
        const config = await new Promise((resolve, reject) => apiBrightsign.getExternal(`/v1/external/brightsign/preview`, this.token)
          .then(response => {
            if (!response) return
            const pSize = response.presentationSize
            const presentationWidth = pSize && pSize.width ? pSize.width : 1920
            const presentationHeight = pSize && pSize.height ? pSize.height : 1080
            response.presentationID = this.id
            response.width = !response.vertical ? this.width : this.calcSize(this.width, presentationWidth, presentationHeight)
            response.height = !response.vertical ? this.calcSize(this.width, presentationWidth, presentationHeight) : this.width
            response.originalWidth = response.vertical ? presentationHeight : presentationWidth
            response.originalHeight = response.vertical ? presentationWidth : presentationHeight

            if (response.zones) {
              
              response.zones = response.zones.filter(x => ['EnhancedAudio', 'AudioOnly'].indexOf(x.zoneType) < 0)
              const messages = response.zones.filter(x => x.zoneType === 'Ticker')
              response.zones = response.zones.filter(x => x.zoneType !== 'Ticker')
              const result = []
              result.push(...response.zones.filter(x => !x.html || x.html.length === 0).map(item => {
                item.originalWidth = response.vertical ? item.height : item.width
                item.originalHeight = response.vertical ? item.width : item.height
                item.originalTop = item.top
                item.originalRight = item.right
                item.top = this.calcSize(this.width, presentationWidth, item.top)
                item.right = this.calcSize(this.width, presentationWidth, item.right)
                const tmpWidth = response.vertical ? this.calcSize(this.width, presentationWidth, item.height) : this.calcSize(this.width, presentationWidth, item.width)
                const tmpHeight = response.vertical ? this.calcSize(this.width, presentationWidth, item.width) : this.calcSize(this.width, presentationWidth, item.height)
                item.width = tmpWidth //response.vertical ? this.calcSize(this.width, presentationWidth, item.height, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.width)
                item.height = tmpHeight//response.vertical ? this.calcSize(this.width, presentationWidth, item.width, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.height)
                return item
              }))
              result.push(...response.zones.filter(x => x.html && x.html.length > 0).map(item => {
                item.originalWidth = response.vertical ? item.height : item.width
                item.originalHeight = response.vertical ? item.width : item.height
                item.originalTop = item.top
                item.originalRight = item.right
                item.top = this.calcSize(this.width, presentationWidth, item.top)
                item.right = this.calcSize(this.width, presentationWidth, item.right)
                const tmpWidth = response.vertical ? this.calcSize(this.width, presentationWidth, item.height) : this.calcSize(this.width, presentationWidth, item.width)
                const tmpHeight = response.vertical ? this.calcSize(this.width, presentationWidth, item.width) : this.calcSize(this.width, presentationWidth, item.height)
                item.width = tmpWidth //response.vertical ? this.calcSize(this.width, presentationWidth, item.height, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.width)
                item.height = tmpHeight//response.vertical ? this.calcSize(this.width, presentationWidth, item.width, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.height)
                return item
              }))
              console.log('ddd', messages)
              if (messages.length > 0)
                result.push(...messages.map(item => {
                  item.originalWidth = response.vertical ? item.height : item.width
                  item.originalHeight = response.vertical ? item.width : item.height
                  item.originalTop = item.top
                  item.originalRight = item.right
                  item.top = this.calcSize(this.width, presentationWidth, item.top)
                  item.right = this.calcSize(this.width, presentationWidth, item.right)
                  const tmpWidth = response.vertical ? this.calcSize(this.width, presentationWidth, item.height) : this.calcSize(this.width, presentationWidth, item.width)
                  const tmpHeight = response.vertical ? this.calcSize(this.width, presentationWidth, item.width) : this.calcSize(this.width, presentationWidth, item.height)
                  item.width = tmpWidth //response.vertical ? this.calcSize(this.width, presentationWidth, item.height, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.width)
                  item.height = tmpHeight//response.vertical ? this.calcSize(this.width, presentationWidth, item.width, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.height)
                  return item
                }))
              response.zones = result
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
          }))

        for (let item of config.zones) {
          if (item && item.image && item.image.name) {
            item.background = await new Promise((resolve, reject) => apiBrightsign.getExternal(`/v1/external/brightsign/contents/${item.image.name}`, this.token)
              .then(response => {
                resolve(response.map(item => item.physicalPath).shift())
              })
              .catch(error => {
                reject(error)
              }))
          }
          if (item.states && item.states.items) {
            for (let state of item.states.items) {
              if (state.image && state.image.name) {
                state.background = await new Promise((resolve, reject) => apiBrightsign.getExternal(`/v1/external/brightsign/contents/${state.image.name}`, this.token)
                  .then(response => {
                    resolve(response.map(item => item.physicalPath).shift())
                  })
                  .catch(error => {
                    reject(error)
                  }))
              }
            }
          }
        }
        this.config = config
        this.loadingData = false
      } catch (error) {
        console.log(error)
      }
    },
    getSpeedFactorName (v) {
      return this.speedFactors.filter(x => x.id === v).map(item => item.name).shift()
    },
    getSize (v) {
      return (this.width * v) / this.presentationWidth//1920
    },
    preparePreview () {
      this.template = this.templates.filter(x => x.ID === this.templateID).shift()
    },
    prepareColor (id) {
      return this.zones.filter(x => x.Zone === id).map(item => item.Color ? `#${item.Color}` : 'transparent').shift()
    },
    prepareTextColor (id) {
      return this.zones.filter(x => x.Zone === id).map(item => item.TextColor ? `#${item.TextColor}` : 'transparent').shift()
    },
    prepareTextSize (id) {
      const aux = this.zones.filter(x => x.Zone === id).map(item => item.TextSize).shift()
      return this.getSize(aux) * 0.7
    },
    prepareXML (id) {
      const aux = this.zones.filter(x => x.Zone === id).map(item => item.XML).shift()
      return aux ? aux.split(';') : []
    },
  },
}
</script>
